import { subDays, startOfDay, endOfDay, differenceInDays } from 'date-fns';

export function setDate(): Date[] {
  const from = subDays(startOfDay(new Date()), 6);
  const to = endOfDay(new Date());

  const previousDayFrom = startOfDay(from);
  const previousDayTo = endOfDay(to);

  const difference = differenceInDays(previousDayTo, previousDayFrom);
  previousDayTo.setDate(previousDayFrom.getDate() - 1);
  previousDayFrom.setDate(previousDayFrom.getDate() - (difference + 1));

  return [previousDayFrom, previousDayTo];
}

interface FormConfig {
  controlName: string;
  controlValue: any;
  validators: string[];
  disabled: boolean;
}

export const statisticDateFrom = subDays(startOfDay(new Date()), 6);
export const statisticDateTo = endOfDay(new Date());

export const billingFilter: FormConfig[] = [
  { controlName: 'type', controlValue: 'ssp', validators: [], disabled: false },
  { controlName: 'endpoint', controlValue: 0, validators: [], disabled: false },
  { controlName: 'company', controlValue: 0, validators: [], disabled: false },
  { controlName: 'dateRange', controlValue: [startOfDay(new Date()), endOfDay(new Date())], validators: [], disabled: false },
];

export const newCompany: FormConfig[] = [
  { controlName: 'name', controlValue: '', validators: ['required'], disabled: false },
  { controlName: 'domain', controlValue: '', validators: [], disabled: false },
  { controlName: 'contact', controlValue: '', validators: [], disabled: false },
  { controlName: 'email', controlValue: '', validators: ['required', 'email'], disabled: false },
  { controlName: 'terms', controlValue: 30, validators: [], disabled: false },
  { controlName: 'start', controlValue: new Date(), validators: [], disabled: false },
];

export const companySettings: FormConfig[] = [
  { controlName: 'name', controlValue: '', validators: ['required'], disabled: false },
  { controlName: 'domain', controlValue: '', validators: [], disabled: false },
  { controlName: 'contact', controlValue: '', validators: [], disabled: false },
  { controlName: 'email', controlValue: '', validators: ['required', 'email'], disabled: false },
  { controlName: 'terms', controlValue: 30, validators: [], disabled: false },
  { controlName: 'start', controlValue: new Date(), validators: [], disabled: false },
  { controlName: 'cookie_sync', controlValue: '', validators: [], disabled: false },
  { controlName: 'sync_url', controlValue: '', validators: [], disabled: false },
  { controlName: 'sync_url_iframe', controlValue: '', validators: [], disabled: false },
  { controlName: 'company_sync_url', controlValue: '', validators: [], disabled: true },
  { controlName: 'cookie_storage', controlValue: '', validators: [], disabled: false },
  { controlName: 'date', controlValue: '', validators: [], disabled: false },
  { controlName: 'id', controlValue: '', validators: [], disabled: false },
  { controlName: 'invoice', controlValue: '', validators: [], disabled: false },
  { controlName: 'adapter_type', controlValue: null, validators: [], disabled: false },
  { controlName: 'rubicon_active', controlValue: false, validators: [], disabled: false },
  { controlName: 'rubicon_username', controlValue: '', validators: [], disabled: false },
  { controlName: 'rubicon_password', controlValue: '', validators: [], disabled: false },
];

export const droppedRequest: FormConfig[] = [
  { controlName: 'dateRange', controlValue: [startOfDay(new Date()), endOfDay(new Date())], validators: [], disabled: false },
  { controlName: 'groupByDate', controlValue: 'daily', validators: [], disabled: false },
  { controlName: 'overviewType', controlValue: 'incoming', validators: [], disabled: false },
  { controlName: 'sspId', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'dspId', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'trafficType', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'country', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'adFormat', controlValue: [-1], validators: [], disabled: false },
];

export const filterList: FormConfig[] = [
  { controlName: 'name', controlValue: '', validators: ['required'], disabled: false },
  { controlName: 'record_type', controlValue: 'bundle_domain', validators: [], disabled: false },
  { controlName: 'type', controlValue: 'white', validators: [], disabled: false },
  { controlName: 'typeList', controlValue: 'Domains/Bundles', validators: [], disabled: false },
  { controlName: 'is_all_dsp', controlValue: false, validators: [], disabled: false },
  { controlName: 'is_all_ssp', controlValue: false, validators: [], disabled: false },
  { controlName: 'endpoint_dsp', controlValue: null, validators: ['required'], disabled: false },
  { controlName: 'endpoint_ssp', controlValue: null, validators: ['required'], disabled: false },
  { controlName: 'has_grouped_dsp', controlValue: 0, validators: [], disabled: false },
  { controlName: 'has_grouped_ssp', controlValue: 0, validators: [], disabled: false },
  { controlName: 'endpoint_groups', controlValue: { ssp: [], dsp: [] }, validators: [], disabled: false },
  { controlName: 'search', controlValue: '', validators: [], disabled: false },
  { controlName: 'page', controlValue: 1, validators: [], disabled: false },
  { controlName: 'rows', controlValue: 15, validators: [], disabled: false },
  { controlName: 'bundleValue', controlValue: null, validators: [], disabled: false },
  { controlName: 'is_case_sensitive', controlValue: true, validators: [], disabled: false },
  { controlName: 'is_include_subdomains', controlValue: false, validators: [], disabled: false },
];

export const filterListFilters: FormConfig[] = [
  { controlName: 'type', controlValue: 'all', validators: [], disabled: false },
  { controlName: 'category', controlValue: 'all', validators: [], disabled: false },
  { controlName: 'searchValue', controlValue: null, validators: [], disabled: false },
  { controlName: 'ssp', controlValue: 0, validators: [], disabled: false },
  { controlName: 'dsp', controlValue: 0, validators: [], disabled: false },
];

export const incomingTrafficLogger: FormConfig[] = [
  { controlName: 'region', controlValue: '', validators: ['required'], disabled: false },
  { controlName: 'aggregate', controlValue: 1, validators: ['required'], disabled: false },
  { controlName: 'time', controlValue: 1, validators: ['required'], disabled: false },
  { controlName: 'ssp', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'type', controlValue: 'banner', validators: ['required'], disabled: false },
  { controlName: 'devtypes', controlValue: [], validators: [], disabled: false },
  { controlName: 'countries', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'browsers', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'categories', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'languages', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'carriers', controlValue: [], validators: [], disabled: false },
  { controlName: 'os', controlValue: [], validators: [], disabled: false },
  { controlName: 'sizes', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'conntypes', controlValue: [], validators: [], disabled: false },
  { controlName: 'domains', controlValue: [], validators: [], disabled: false },
  { controlName: 'bundles', controlValue: [], validators: [], disabled: false },
  { controlName: 'traffic', controlValue: [], validators: [], disabled: false },
  { controlName: 'maxbf', controlValue: 0, validators: [], disabled: false },
  { controlName: 'tmax', controlValue: 0, validators: [], disabled: false },
  { controlName: 'ifa', controlValue: false, validators: [], disabled: false },
  { controlName: 'includeExamples', controlValue: false, validators: [], disabled: false },
  { controlName: 'sites', controlValue: [], validators: [], disabled: false },
  { controlName: 'apps', controlValue: [], validators: [], disabled: false },
];

export const login: FormConfig[] = [
  { controlName: 'email', controlValue: null, validators: ['required', 'email'], disabled: false },
  { controlName: 'password', controlValue: null, validators: ['required'], disabled: false },
  { controlName: 'remember', controlValue: false, validators: [], disabled: false },
];

export const reset: FormConfig[] = [
  { controlName: 'email', controlValue: null, validators: ['required', 'email'], disabled: false },
];

export const sampleLogger: FormConfig[] = [
  { controlName: 'content', controlValue: null, validators: [], disabled: false },
  { controlName: 'exclude', controlValue: 0, validators: [], disabled: false },
  { controlName: 'event_id', controlValue: -1, validators: [], disabled: false },
  { controlName: 'ssp_id', controlValue: 'all', validators: [], disabled: false },
  { controlName: 'dsp_id', controlValue: 'all', validators: [], disabled: false },
  { controlName: 'ad_format_id', controlValue: -1, validators: [], disabled: false },
  { controlName: 'traffic_id', controlValue: -1, validators: [], disabled: false },
  { controlName: 'ssp_endpoint_type', controlValue: -1, validators: [], disabled: false },
  { controlName: 'dsp_endpoint_type', controlValue: -1, validators: [], disabled: false },
  { controlName: 'ssp_company_id', controlValue: -1, validators: [], disabled: false },
  { controlName: 'dsp_company_id', controlValue: -1, validators: [], disabled: false },
];

export const scannerStatistic: FormConfig[] = [
  { controlName: 'date', controlValue: [statisticDateFrom, statisticDateTo], validators: [], disabled: false },
  { controlName: 'compareDate', controlValue: setDate(), validators: [], disabled: false },
  { controlName: 'groupBy', controlValue: 'day', validators: [], disabled: false },
  { controlName: 'sspId', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'dspId', controlValue: [-1], validators: [], disabled: false },
  { controlName: 'scannerName', controlValue: null, validators: ['required'], disabled: false },
  { controlName: 'blockReason', controlValue: -1, validators: [], disabled: false },
  { controlName: 'domains', controlValue: null, validators: [], disabled: false },
  { controlName: 'averageIvt', controlValue: null, validators: [], disabled: false },
  { controlName: 'blockedReq', controlValue: null, validators: [], disabled: false },
  { controlName: 'requests', controlValue: null, validators: [], disabled: false },
  { controlName: 'selectedAttribute', controlValue: null, validators: [], disabled: false },
  { controlName: 'selectedMetric', controlValue: [], validators: [], disabled: false },
];